export const convertCsvToJson = async (file, normalizeTestName) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => {
            try {
                // Any CSV needs to be validated before converted
                const text = e.target.result;
                const lines = text.split("\n").map(line => line.trim()).filter(line => line);

                const headers = lines[0].split(",").map(h => h.trim().toLowerCase());

                const body = lines.slice(1).map(line => {
                    const values = line.split(",").map(v => v.trim());
                    let entry = {};

                    headers.forEach((header, index) => {
                        if (header === "result" || header === "lab_low" || header === "lab_high") {
                            entry[header] = values[index] ? parseFloat(values[index]) : null;
                        } else {
                            entry[header] = values[index] || "";
                        }
                    });

                    // Add field alias with the normalized testname
                    entry.alias = normalizeTestName(entry.test_name || "");

                    return entry;
                });

                // Extract test date from filename (YYYYMMDD pattern)
                const match = file.name.match(/\d{8}/);
                const testdate = match ? parseInt(match[0], 10) : null;

                const jsonData = {
                    header: { source: "csv", type: "bloodtest", testdate: testdate },
                    body
                };

                resolve(jsonData);
            } catch (error) {
                reject("Error parsing CSV file.");
            }
        };
        reader.readAsText(file);
    });
};
